// @flow
import { startProgress, finishProgress } from "../actions/ProgressIndicator";

import type Locales from "../../i18n/Locales";
import type { SetLocalesAction, UpdateLocaleAction } from "./types";
import type { ThunkAction } from "../types";

/**
 * Update current locale
 */
export const receiveLocale = (locale: string): UpdateLocaleAction => ({
  type: "UPDATE_LOCALE",
  payload: locale,
});

/**
 * Change locale of application and redirect
 */
export const updateLocale =
  (locale: string): ThunkAction<> =>
  (dispatch) => {
    dispatch(startProgress());
    dispatch(receiveLocale(locale));
    dispatch(finishProgress());
  };

/**
 */
export const setLocales = (
  locales: Locales,
  locale: string,
): SetLocalesAction => ({
  type: "SET_LOCALES",
  payload: {
    locales,
    locale,
  },
});
